import {Utils} from "@/main/webapp/resources/src/vue/infrastructure/utils/helpers";
import CcProductstock from "@/main/webapp/resources/src/vue/domain/productstock/cc-productstock";

export default class CcWishlistTempParams {
	private _uniqueId: string = null;
	private _wishlistName: string = "";
	private _wishlistPrivacy: any = null;
	private _productCodes: Array<string> = [];
	private _formErrors: Array<any> = [];
	private _productStock: CcProductstock = null;

	constructor () {
		this._wishlistPrivacy = Utils.whislistPrivacyOptions.find((option: any) => option.code === "PRIVATE");
	}

	get uniqueId (): string {
		return this._uniqueId;
	}

	set uniqueId (uniqueId: string) {
		this._uniqueId = uniqueId;
	}

	get wishlistName (): string {
		return this._wishlistName;
	}

	set wishlistName (wishlistName: string) {
		this._wishlistName = wishlistName;
	}

	get wishlistPrivacy (): any {
		return this._wishlistPrivacy;
	}

	set wishlistPrivacy (wishlistPrivacy: any) {
		this._wishlistPrivacy = wishlistPrivacy;
	}

	get productCodes (): Array<string> {
		return this._productCodes;
	}

	set productCodes (productCodes: Array<string>) {
		this._productCodes = productCodes;
	}

	get formErrors (): Array<any> {
		return this._formErrors;
	}

	set formErrors (formErrors: Array<any>) {
		this._formErrors = formErrors;
	}

	get productStock (): CcProductstock {
		return this._productStock;
	}

	set productStock (productStock: CcProductstock) {
		this._productStock = productStock;
	}
}
